import { render, staticRenderFns } from "./AdminWhatsappConversations.vue?vue&type=template&id=752a6e04&scoped=true"
import script from "./AdminWhatsappConversations.vue?vue&type=script&lang=js"
export * from "./AdminWhatsappConversations.vue?vue&type=script&lang=js"
import style0 from "./AdminWhatsappConversations.vue?vue&type=style&index=0&id=752a6e04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752a6e04",
  null
  
)

export default component.exports